module.exports = __webpack_public_path__ + "img/Contact.66ecec65.png";